export default "__VITE_ASSET__DTa1lYLt__"